module.exports = __webpack_public_path__ + "static/media/stability-improvement-desktop.19d2d98d.svg";